import { Category } from '@modules/husleie-framework/src/enums/Category.enum';
import { RentalAdjustmentTypeEnum } from '@modules/husleie-framework/src/types/ContractRentalAdjustment.entity';
import { LandlordTypeEnum } from '@modules/husleie-framework/src/types/Landlord.entity';
import { LimitedRentDurationEnum, RentDurationEnum } from '@modules/husleie-framework/src/types/Rent.entity';
import { RentalObjectFurnishingStandardEnum } from '@modules/husleie-framework/src/types/RentalObject.entity';
import { SignMethodEnum, SigningStatusEnum } from '@modules/husleie-framework/src/types/Signing.entity';
import type ContractState from '@modules/store/contract/types/ContractState.entity';

export const state: ContractState = {
  loading: null,
  loaded: false,
  apiError: false,
  fromSignup: false,
  contract: {
    uuid: '',
    status: SigningStatusEnum.OPEN,
    landlord: {
      type: LandlordTypeEnum.PRIVATE,
      id: null,
    },
    tenant: {},
    coTenants: [],
    amountOfResidents: 1,
    rentalObject: {
      category: Category.APARTMENT,
      rooms: [],
      furnishingStandard: RentalObjectFurnishingStandardEnum.UNFURNISHED,
      furniture: [],
      storageDetail: [],
      keychain: {
        keys: [],
      },
      houseRulesUploads: [],
      additionalDocuments: [],
      useDefaultHouseRules: true,
      parkingFacilities: false,
    },
    rentalAdjustment: {
      rentalAdjustment: RentalAdjustmentTypeEnum.COMPARABLE_RENT,
      tiers: [],
      rentRegulation: false,
      firstUsedAndRented: true,
      renovationsLastThreeYears: true,
      occupancyAfterRenovations: true,
    },
    deposit: {
      ownDefinedAmount: 0,
      ownDefined: false,
      months: 3,
      depositSolutions: [],
    },
    rentalCalculation: {
      additionalCost: 'combined',
      additionalCostTypes: false,
      utilityCostBilling: 'calendarYear',
      utilityItems: [],
      heatingCostBilling: 'calendarYear',
    },
    sign: SignMethodEnum.DIGITAL,
    rent: {
      durationType: RentDurationEnum.UNLIMITED, // default value
      limitedRentDurationType: LimitedRentDurationEnum.OWN_USE,
      limitedRentReason: '',
      bindingPeriod: undefined,
      noticePeriod: undefined,
    },
    previousTenant: {
      available: false,
      lastRent: null,
    },
    tenantFeedback: null,
    mode: 'created',
    preview: {},
    currentUpsellPlan: {},
  },
};
